
import { store } from '../../../boot-client';
import { SET_NOTIFICATION } from './constants';

export const notify = (message, type, sticky = false, timeout = 2000, messageLink = null) => {
    store.dispatch({ type: SET_NOTIFICATION, data: { message, type, sticky, timeout, messageLink } });
};
